module.exports = __webpack_public_path__ + "assets/img/pcdsjfx.9f1b64e8.png";